"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_universal_interface_1 = require("react-universal-interface");
exports.default = react_universal_interface_1.render;
//# sourceMappingURL=renderProp.js.map